<template>
  <div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title class="text-h5">
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text>{{ dialogMessage }}</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded large text @click="onGoMain" v-if="dialogError">
            Закрыть
          </v-btn>
          <v-btn rounded large text @click="onGoMain" v-if="!dialogError">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-show="loading" class="progress-logo">
      <v-layout align-center justify-center column fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
          :size="70"
          :width="5"
        ></v-progress-circular>
      </v-layout>
    </div>

    <div v-show="!loading">
      <v-card class="mx-auto" max-width="auto" v-if="upd && !isCorrectingSum">
        <v-card-text>
          <p class="text-h5 text--primary">УПД №{{ upd.docNumber }}</p>
          <p>
            <b>{{ upd.contractor.contract.number }}</b>
          </p>
          <p>{{ upd.contractor.name }}</p>
          <p>{{ upd.deliveryAddress.name }}</p>

          <v-simple-table class="mb-6">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Баланс до отгрузки</td>
                  <td>
                    {{ (upd.totalPay - upd.clientPay).toFixed(2) }}
                    <span class="currency-rub"></span>
                  </td>
                </tr>
                <tr>
                  <td>Сумма отгрузки из УПД</td>
                  <td>{{ upd.totalPay }} <span class="currency-rub"></span></td>
                </tr>
                <tr>
                  <td><b>Взять с клиента (с учетом переплаты)</b></td>
                  <td>
                    <span class="brg-mark"
                      ><span class="text-h6">{{ updSum }}</span>
                      <span class="currency-rub"></span
                    ></span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-spacer></v-spacer>

          <v-btn
            block
            class="goods-link"
            @click="onShowDetails"
            v-if="!showDetails && (paymentIsAvailable || goodList.length > 0)"
          >
            <v-icon dark> mdi-menu-down-outline </v-icon>
            Удаление товарных позиций<br />(отказ / недостача)
          </v-btn>
          <v-btn
            block
            class="goods-link"
            @click="onShowDetails"
            v-if="showDetails"
          >
            <v-icon dark> mdi-menu-up-outline </v-icon>
            Скрыть
          </v-btn>

          <div v-show="showDetails">
            <v-text-field
              class="top20"
              v-model="search"
              label="Введите наименование/артикул товара"
              type="text"
              prepend-inner-icon="mdi-magnify"
              clearable
            ></v-text-field>

            <raw-product-list-row
              v-for="good in goodList"
              :key="good.id"
              :good="good"
              :paymentIsAvailable="paymentIsAvailable"
              :updSum="updSum"
              :deletionProhibited="deletionProhibited"
            />
          </div>

          <v-spacer></v-spacer>

          <v-btn
            block
            x-large
            @click="onSendCheck"
            class="send-check top20"
            v-if="paymentIsAvailable"
          >
            <v-icon dark> mdi-rocket-launch </v-icon>
            Отправить чек на сумму
            <div class="text-h6">
              {{ updSum }} <span class="currency-rub"></span>
            </div>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            block
            x-large
            class="send-check"
            @click="onCorrecting"
            v-if="paymentIsAvailable"
          >
            Сформировать чек на другую сумму
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-text>
      </v-card>

      <correct-sum
        :updSum="updSum"
        :upd="upd"
        v-if="isCorrectingSum"
        @sendCheck="onConfirmedSendCheck"
      />

      <v-spacer></v-spacer>

      <v-container class="top40">
        <v-row align="center" justify="space-around">
          <v-btn
            v-if="upd"
            class="readmore-link"
            color="white"
            @click="onSearch"
          >
            <v-icon dark> mdi-arrow-u-left-bottom </v-icon>
            {{ backButtonName }}
          </v-btn>
        </v-row>
      </v-container>
    </div>
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  </div>
</template>

<script>
import RawProductListRow from "@/components/RawProductListRow";
import ConfirmDialogue from "@/components/ConfirmDialogue.vue";
import CorrectSum from "@/components/CorrectSum";

export default {
  name: "RawUpd",
  components: {
    RawProductListRow,
    ConfirmDialogue,
    CorrectSum,
  },
  props: {
    upd: Object,
  },
  data: () => ({
    search: "",
    showDetails: false,
    dialogMessage: "",
    dialogTitle: "",
    dialog: false,
    dialogError: false,
    loading: false,
  }),
  computed: {
    goodList() {
      let oldGoodList = this.goods;
      let newGoodList = [];

      if (this.search === null) {
        newGoodList = oldGoodList;
        return newGoodList;
      }

      const search = this.search.toLowerCase();
      let key;
      let el;

      for (key in oldGoodList) {
        el = oldGoodList[key];
        if (
          el.name.toLowerCase().indexOf(search) != -1 ||
          el.article.toLowerCase().indexOf(search) != -1
        ) {
          newGoodList.push(el);
        }
      }

      return newGoodList;
    },
    backButtonName() {
      return this.isCorrectingSum ? "Вернуться к поиску УПД" : "Назад";
    },
    goods() {
      return this.$store.getters.goods;
    },
    updSum() {
      return this.$store.getters.updSum;
    },
    isCorrectingSum() {
      return this.$store.getters.isCorrectingSum;
    },
    paymentIsAvailable() {
      return this.updSum > 0;
    },
    deletionProhibited() {
      return this.upd && this.upd.deleteProhibited;
    },
  },
  methods: {
    onShowDetails() {
      this.showDetails = !this.showDetails;
    },
    onScan() {
      this.$store.commit("clearUpd");
      this.$store.commit("finishCorrectSum");
      this.$router.push({ name: "UpdScan" });
    },
    onGoMain() {
      this.$store.commit("clearUpd");
      this.$store.commit("finishCorrectSum");
      this.$router.push({ name: "Home" });
    },
    onSearch() {
      this.$refs.confirmDialogue
        .show({
          title: "Покинуть страницу",
          message: "Вернуться к поиску УПД?",
          okButton: "Да",
          showEmail: false,
        })
        .then((result) => {
          if (result) {
            this.dialog = false;
            this.$store.commit("clearUpd");
            this.$store.commit("finishCorrectSum");
          }
        });
    },
    onCorrecting() {
      this.$refs.confirmDialogue
        .show({
          title: "Изменить сумму?",
          message: "Текущая сумма: ",
          item: this.$store.getters.updSum + " руб",
          okButton: "Изменить",
        })
        .then((result) => {
          if (result) {
            this.$store.commit("startCorrectSum");
          }
        });
    },
    onSendCheck() {
      this.$refs.confirmDialogue
        .show({
          title: "Отправить чек",
          message: "Чек на сумму",
          item: this.$store.getters.updSum + " руб",
          okButton: "Отправить",
          showEmail: true,
          email: this.upd.contractor.email,
        })
        .then((result) => {
          if (result) {
            let check = {
              checkExtid: this.$uuid.v4(),
              contractExtid: this.upd.contractor.contract.id,
              contractNumber: this.upd.contractor.contract.number,
              contractorName: this.upd.contractor.name,
              deliveryAddress: this.upd.deliveryAddress.name,
              transporterExtid: this.upd.transporterExtid,
              updExtid: this.upd.docId.toString(),
              updNumber: this.upd.docNumber,
              amount: this.$store.getters.updSum.toString(),
              email: this.$store.getters.getContractorEmail,
              isPrepaid: false,
              upd: this.upd,
            };
            this.$store.commit("fillCheckToSend", check);
            this.$store.commit(
              "updateCheckSum",
              parseFloat(this.$store.getters.updSum)
            );
            this.onConfirmedSendCheck();
          }
        });
    },
    onConfirmedSendCheck(
      quiet = false,
      successMessage = null,
      successTitle = "Чек сформирован"
    ) {
      this.loading = true;
      let check = this.$store.getters.checkToSend;
      let action =
        check.isPrepaid === true ? "create_new_prepaid" : "create_new_upd";
      this.$store
        .dispatch(action, check)
        .then((data) => {
          if (quiet === false) {
            this.dialog = true;
            this.dialogTitle = successTitle;
            this.dialogMessage =
              successMessage === null
                ? "Чек на сумму " +
                  this.$store.getters.checkSum +
                  " руб. успешно сформирован."
                : successMessage;
            this.dialogError = false;
          }
          console.log("data", data);
          this.$store.commit("clearCheckToSend");
        })
        .catch((err) => {
          this.dialogError = true;
          this.dialog = true;
          this.dialogTitle = "Ошибка";
          this.dialogMessage = "Ошибка формирования чека";
          let error = JSON.parse(err.request.responseText);
          this.dialogMessage =
            error["hydra:description"] !== undefined
              ? error["hydra:description"]
              : error;
          this.loading = false;
        })
        .finally(() => {
          if (quiet === false) {
            this.loading = false;
          }
        });
    },
  },
};
</script>
